import { render, staticRenderFns } from "./meetDetailNew.vue?vue&type=template&id=20a3f1b5"
import script from "./meetDetailNew.vue?vue&type=script&lang=js"
export * from "./meetDetailNew.vue?vue&type=script&lang=js"
import style0 from "./meetDetailNew.vue?vue&type=style&index=0&id=20a3f1b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports